<template>
  <div class="survey">
    <div class="survey-header">
      <span class="title">Anket</span>
      <div class="text">
        <div>
          <span
            >Soru {{ currentQuestionNumber }}/{{ survey?.questionCount }}</span
          >
        </div>
      </div>
    </div>
    <div class="survey-question">
      <span>{{ getCurrentQuestion?.value }}</span>
    </div>
    <SurveyQuestionAnswers
      :surveyQuestion="getCurrentQuestion"
      :questionCount="survey?.questionCount"
      :surveyId="survey.id"
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import SurveyQuestionAnswers from "./SurveyQuestionAnswers";

export default {
  name: "Survey",
  components: {
    SurveyQuestionAnswers,
  },
  props: {
    survey: Object,
    loading: {
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters({
      currentQuestionNumber: "surveys/getCurrentQuestionNumber",
    }),
    getCurrentQuestion() {
      if (this.survey?.surveyQuestions?.length > 0) {
        return this.survey?.surveyQuestions[this.currentQuestionNumber - 1];
      }
      return null;
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/styles/variables.scss";

.survey {
  &-header {
    display: flex;
    flex-direction: column;
    margin: 0 20px;
    gap: 16px;
    span {
      width: 66px;
      height: 20px;
      font-size: 14px;
      font-weight: 600;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      color: $dark-gray-5;
    }

    .title {
      display: flex;
      align-items: center;
      color: $dark-gray-5;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 20px;
      letter-spacing: -0.05px;
    }

    .counter {
      width: 100%;

      .text {
        font-size: 16px;
        line-height: 1.25;
        text-align: center;
        color: $dark-gray-5;

        span {
          font-weight: bold;
        }
      }
    }
  }

  &-question {
    display: flex;
    flex-direction: row;
    align-items: center;

    span {
      margin: 8px 20px 12px 20px;
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px; /* 138.462% */
      letter-spacing: -0.05px;
      color: $dark-gray-5;
    }
  }
}
</style>
